<div class="banner-container">
  <div class="banner">
    <h3 class="banner__title">
      {{ content?.fields.title }}
    </h3>
    <div class="banner__ingress" [innerHTML]="content?.fields.ingress | richTextToHtml"></div>
    <a class="banner__button" [href]="content?.fields.buttonLink" target="_blank" rel="noopener noreferrer">
      {{ content?.fields.buttonText }}
    </a>
  </div>
</div>
